import { render, staticRenderFns } from "./FileNotFoundPage.vue?vue&type=template&id=90365982&scoped=true&lang=pug&"
import script from "./FileNotFoundPage.vue?vue&type=script&lang=js&"
export * from "./FileNotFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./FileNotFoundPage.vue?vue&type=style&index=0&id=90365982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90365982",
  null
  
)

export default component.exports